<template>
    <div class="pick_share">
        <button class="btn" @click="touchMember">分享给客户</button>
        <button class="btn" @click="touchDesigner">分享给家装设计师</button>
    </div>
</template>

<script>
/* 废弃 */
export default {
    name: "share",
    created() {
        if (this.$route.query.sampleroom) {
            this.$storage.setStorage('sampleroom_info', this.$route.query);
        }
        if (!this.$route.query.remove && !this.$route.query.sampleroom) {
            this.$storage.removeStorage('sampleroom_info');
        }
        // if (  this.$route.query.sampleroom || this.$route.query.sampleroom) {
        //     this.$router.push({
        //         replace: true,
        //         query: {
        //
        //         }
        //     })
        // }
    },
    methods: {
        touchMember() {
            let objData = this.$route.query;
            if (objData.sampleroom == 2) {
                // this.$common.pushEvent('member_share_design', this.$route.query.contractid)

                this.$router.push({
                    path: '/member/v2/index/index',
                    query: {
                        ...objData,
                        // track_action: 'share_design',
                        // track_id: this.$route.query.contractid,
                        // track_uuid: this.$storage.getStorage('page_uuid')
                    }
                })
            } else {
                this.$toast('权限不足')
            }
        },
        touchDesigner() {
            let objData = this.$route.query;
            if (objData.sampleroom == 2) {
                // this.$common.pushEvent('member_share_design', this.$route.query.contractid)

                this.$router.push({
                    path: '/designer/index/index',
                    query: {
                        // track_action: 'share_design',
                        // track_id: this.$route.query.contractid,
                        // track_uuid: this.$storage.getStorage('page_uuid')
                    }
                })
            } else {
                this.$toast('权限不足')
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.pick_share {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #F1F3F6;

    .btn {
        width: 574px;
        height: 98px;
        background: #355D4B;
        border-radius: 12px;

        font-size: 28px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 42px;
    }

    .btn:nth-child(1) {
        margin-bottom: 106px;
    }
}
</style>
